import { of } from "rxjs";
import { map } from "rxjs/operators";
import { ajax } from 'rxjs/ajax';
import {mergeRight } from "ramda";
import { API_BASE_URL, AUTH_BASE_URL, STIP_BASE_URL } from "props";
import { errorOccurred } from "application/redux/applicationActions";
import { logOut } from "auth/authActions";

const FETCH_MODULES_URL = `${API_BASE_URL}/admin/modules?limit=all`;
const getSecurityUserUrl = userId => `${AUTH_BASE_URL}/users/${userId}`;
const getSecurityApplicationUrl = appId => `${AUTH_BASE_URL}/applications/${appId}`;

const COUNTRIES_URL = `${STIP_BASE_URL}/geography/countries`;
const getAdminAreaUrl = country => `${COUNTRIES_URL}/${country}/subdivisions`;

const addOrgId = (urlStr, orgId) => {
  const url = new URL(urlStr);
  const params = url.searchParams;
  params.append("org-id", orgId);
  url.search = params.toString();
  return url.toString();
};

export const ajaxWithAuth = auth => props => {
  const url = auth.currentOrganization ?
    addOrgId(props.url, auth.currentOrganization.id) : props.url;

  console.log(`AJAX call to URL : ${url}`);

  return ajax(
    mergeRight(
      {
        crossDomain: true,
        headers: {
          Authorization: `Bearer ${auth.user.token}`,
          "Content-Type": "application/json",
        },
      },
      mergeRight(props, { url: url }),
    ),
  )
};

export const apiAjax = state => props => ajaxWithAuth(state.auth)(props);

export const errorToAction = error =>
  of(error.status === 401 ? logOut() : errorOccurred(error));

export const ajaxGetAllModules = state =>
  apiAjax(state)({
    url: FETCH_MODULES_URL,
  }).pipe(
    map(ajaxResponse => ajaxResponse.response)
  );

export const ajaxGetSecurityUser = state => userId =>
  apiAjax(state)({
    url: getSecurityUserUrl(userId),
  }).pipe(
    map(ajaxResponse => ajaxResponse.response)
  );

export const ajaxGetSecurityApplication = state => applicationId =>
  apiAjax(state)({
    url: getSecurityApplicationUrl(applicationId),
  }).pipe(
    map(ajaxResponse => ajaxResponse.response)
  );

export const ajaxGetCountries = state =>
  apiAjax(state)({
    url: COUNTRIES_URL,
  }).pipe(
    map(ajaxResponse => ajaxResponse.response)
  );

export const ajaxGetAdminAreas = state => country =>
  apiAjax(state)({
    url: getAdminAreaUrl(country),
  }).pipe(
    map(ajaxResponse => ajaxResponse.response)
  );
